import { create } from "zustand";
import type { Member } from "../api/members";

interface MemberState {
  member: Member | null;
  setMember: (m: Member | null) => void;
  clear: () => void;
}

export const useMemberStore = create<MemberState>((set) => ({
  member: null,
  setMember: (m) => set({ member: m }),
  clear: () => set({ member: null }),
}));
